import { SnackBarBase } from './Snackbar'

export default SnackBarBase
